import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export const FAQSection = () => {
  const faqs = [{
    q: '¿Tengo que dejar el café para siempre?',
    a: 'No. Solo aprenderás a cronometrarlo fuera de la ventana de riesgo nocturno. Tu café de la mañana está completamente a salvo.'
  }, {
    q: '¿Necesito comprar una cama especial o almohadas caras?',
    a: 'No. Te enseñamos a ajustar exactamente lo que ya tienes en tu casa con objetos comunes.'
  }, {
    q: '¿Funciona para el reflujo silencioso (tos crónica, ronquera)?',
    a: 'Sí. Al evitar que el vapor ácido llegue a tus cuerdas vocales durante la noche, los síntomas de reflujo silencioso mejoran significativamente.'
  }, {
    q: '¿Puedo usarlo si actualmente tomo medicamentos para el reflujo?',
    a: 'Sí. Este protocolo es un complemento mecánico que no interfiere con ningún tratamiento médico. Muchos usuarios han podido reducir su dependencia a los fármacos gradualmente bajo supervisión médica.'
  }, {
    q: '¿Cuánto tiempo tardaré en ver resultados?',
    a: 'Los cambios de posición funcionan desde la primera noche. El Protocolo 3-2-1 completo estabiliza el sistema en 4 a 7 días para la mayoría de los usuarios.'
  }, {
    q: '¿En qué formato recibiré el producto?',
    a: 'PDF descargable inmediatamente después de tu compra. Compatible con cualquier dispositivo: teléfono, tablet, laptop o computadora.'
  }];
  return <section className="py-12" data-id="element-226">
      <FadeIn data-id="element-227">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8 text-center" data-id="element-228">
          Preguntas Frecuentes
        </h2>
        <div className="space-y-4" data-id="element-229">
          {faqs.map((faq, i) => <div key={i} className="bg-slate-900 border border-slate-800 rounded-xl p-6" data-id="element-230">
              <h4 className="text-lg font-bold text-white mb-3 flex gap-3 items-start" data-id="element-231">
                <span className="text-amber-500 flex-shrink-0" data-id="element-232">❓</span>
                <span data-id="element-233">{faq.q}</span>
              </h4>
              <p className="text-slate-300 pl-8 leading-relaxed" data-id="element-234">{faq.a}</p>
            </div>)}
        </div>
      </FadeIn>
    </section>;
};